"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createController;

var _Subject = require("rxjs/Subject");

var _ajax = require("../util/ajax");

var _modal = require("../ui/modal");

var Controller = {
    el: null,
    inputs: [],
    errorMessageEl: null,

    inputKeys: [],
    isFormDirty: false,
    action: "",

    onErrorEvent: null,
    onSucccessEvent: null,

    onError: null,
    onSucccess: null,

    init: init
};

function createController(selector, onSucccess, onError) {
    var Obj = Object.create(Controller);
    Obj.init(selector, onSucccess, onError);
    return Obj;
}

function init(selector, onSucccess, onError) {
    if (typeof selector === "string") {
        this.el = document.querySelector(selector);
    } else {
        this.el = selector;
    }

    if (!this.el) {
        return;
    }

    this.errorMessageEl = this.el.querySelector(".js-form-errros");

    this.inputs = this.el.querySelectorAll("[name]");
    this.inputs = Array.from(this.inputs);
    this.inputs = this.inputs.reduce(function (acc, input) {
        if (acc[input.name]) {
            return acc;
        }

        acc[input.name] = input;
        return acc;
    }, {});

    this.inputKeys = Object.keys(this.inputs);
    this.action = this.el.action;

    this.el.addEventListener("submit", handleSubmit.bind(this));
}
function handleSubmit(evt) {
    evt.preventDefault();

    var formData = getFormValueObj.call(this);
    var errorMessageEl = document.querySelector(".js-form-errros");
    errorMessageEl.innerHTML = "";
    errorMessageEl.classList.remove("active");

    (0, _ajax.post)(this.action, formData).then(function (data) {
        return JSON.parse(data);
    }).then(function (data) {
        handleReturn(data, formData);
    });
}

function handleReturn(data, formData) {
    var errorMessageEl = document.querySelector(".js-form-errros");
    errorMessageEl.innerHTML = "";
    errorMessageEl.classList.remove("active");

    if (data.success) {
        var baseUrl = new URL(location);
        baseUrl.searchParams.append("popup", true);
        window.location.href = baseUrl.href;
        return;
    } else {
        errorMessageEl.innerHTML = "<p>" + data.msg + "</p>";
        errorMessageEl.classList.add("active");
        return;
    }
}

function clearForm(formClass) {
    var form = document.querySelector("." + formClass);
    form.reset();
}

function getFormValueObj() {
    var data = new FormData(this.el);
    data = Array.from(data.entries());
    data = data.reduce(function (acc, el) {
        acc[el[0]] = el[1];
        return acc;
    }, {});

    return data;
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/form/controller.js
// module id = ./resources/assets/js/src/form/controller.js
// module chunks = 0